import { useTranslation } from "react-i18next";
import { useBankingPage } from "../../hooks/useBankingPage";
import {
  BalanceCard,
  SummaryCards,
  TransactionFilters,
  TransactionList,
  AccountSelector,
  BankingPageSkeleton,
} from "./components";

export default function BankingPage() {
  const { t } = useTranslation("BankingPage");
  const page = useBankingPage();

  if (page.isLoading && !page.statement) {
    return (
      <>
        <title>{t("meta.title")}</title>
        <section className="flex-1">
            <div className="flex items-center justify-between pb-4 border-b surface-base-stroke mb-5">
              <h1 className="text-display-xs content-base-primary">{t("page.title")}</h1>
            </div>
            <BankingPageSkeleton />
        </section>
      </>
    );
  }

  if (page.isServiceError) {
    return (
      <>
        <title>{t("meta.title")}</title>
        <section className="flex-1">
            <div className="flex items-center justify-between pb-4 border-b surface-base-stroke mb-5">
              <h1 className="text-display-xs content-base-primary">{t("page.title")}</h1>
            </div>
            <div className="flex flex-col items-center justify-center py-20 gap-4">
              <div className="text-body-regular-lg content-base-secondary">{t("errors.serviceUnavailable")}</div>
              <div className="text-body-regular-sm content-base-tertiary">{t("errors.serviceUnavailableHint")}</div>
              <button
                type="button"
                onClick={page.refetchAccounts}
                className="px-4 py-2 background-brand-fill text-white rounded-md hover:opacity-90 outline-none">
                {t("page.retry")}
              </button>
            </div>
        </section>
      </>
    );
  }

  if (page.error && !page.isServiceError) {
    return (
      <>
        <title>{t("meta.title")}</title>
        <section className="flex-1">
            <div className="flex items-center justify-between pb-4 border-b surface-base-stroke mb-5">
              <h1 className="text-display-xs content-base-primary">{t("page.title")}</h1>
            </div>
            <div className="flex flex-col items-center justify-center py-20 gap-4">
              <div className="text-body-regular-lg content-base-secondary">{t("page.errorLoading")}</div>
              <button
                type="button"
                onClick={page.refetchAccounts}
                className="px-4 py-2 background-brand-fill text-white rounded-md hover:opacity-90 outline-none">
                {t("page.retry")}
              </button>
            </div>
        </section>
      </>
    );
  }

  return (
    <>
      <title>{t("meta.title")}</title>
      <section className="flex-1">
          <div className="flex items-end justify-between pb-4 border-b surface-base-stroke mb-5">
            <div className="flex flex-col">
              <h1 className="text-display-xs content-base-primary">{t("page.title")}</h1>
            </div>
            <div className="flex justify-end items-end">
              <AccountSelector
                accounts={page.accounts}
                selectedIban={page.selectedIban}
                onSelect={page.setSelectedIban}
              />
            </div>
          </div>

          <div className="flex flex-col gap-6">
            {page.selectedAccount && <BalanceCard balance={page.selectedAccount.balance} locale={page.locale} />}

            {page.statement && (
              <SummaryCards
                creditTotal={page.statement.creditTotalSum}
                debitTotal={page.statement.debitTotalSum}
                transactionCount={page.statement.paginationInfo.totalCount}
                locale={page.locale}
              />
            )}

            <TransactionFilters
              search={page.search}
              onSearchChange={page.setSearch}
              typeFilter={page.typeFilter}
              onTypeChange={page.setTypeFilter}
              dateRange={page.dateRange}
              onDateRangeChange={page.handleDateRangeChange}
              locale={page.locale}
            />

            <TransactionList
              transactions={page.filteredTransactions}
              isLoading={page.isFetching}
              locale={page.locale}
            />
          </div>
      </section>
    </>
  );
}

